import React, { useMemo } from 'react';
import { ButtonEvaluation } from './styles';

function SeeAssessment({ item, goToAssessmentView, assessmentType }) {

    const allowSeeAssessment = useMemo(() => {
        const isCorrected = (item.tracking || []).find(item => item.status === 'Corrigido');
        return item.allowassessmentresponse && isCorrected;
    }, [item]);


    const isEditable = useMemo(() => {
        const isCorrected = (item.tracking || []).find(item => item.status === 'Corrigido');
        return assessmentType === 'EXAM' 
                && !isCorrected 
                && item.isOnTime
    }, [item, assessmentType]);


    if(isEditable){
        return (
            <ButtonEvaluation
                onClick={() => goToAssessmentView(item.crCode, true)}
                >
                Editar resposta
            </ButtonEvaluation>
        )
    }

    if(allowSeeAssessment){
        return (
            <ButtonEvaluation onClick={() => goToAssessmentView(item.crCode)}>
                Ver avaliação
            </ButtonEvaluation>
        )
    }
    return null;
}

export default SeeAssessment;
